import React from 'react';
import TextComponent from 'shared/components/TextComponent';

const SMTPlacements = (props) => {
  const name = 'smt';

  const {
    label,
    errorMessage,
    parameters,
    inputId,
    tooltip,
    groupName,
    onChangeParameter,
    required,
    disabled,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);

  return (
    <TextComponent
      name={name}
      label={label}
      inputId={inputId}
      value={parameters[name]}
      tooltip={tooltip}
      required={required}
      groupName={groupName}
      onChange={onChange}
      errorMessage={errorMessage}
      disabled={disabled} />
  );
};

SMTPlacements.defaultProps = {
  label: Spree.translations.parameters.smt,
  tooltip: Spree.helpForParameters.smt,
  required: true,
  inputId: 'smt-placements',
};

export default SMTPlacements;
